export default [
  {
    name: 'unit-create',
    path: '/units/create',
    component: () => import('@/views/units/UnitManage')
  },
  {
    name: 'unit-edit',
    path: '/units/:id/edit',
    component: () => import('@/views/units/UnitManage')
  },
  {
    name: 'unit-view',
    path: '/units/:id/view',
    component: () => import('@/views/units/UnitManage')
  },
  {
    name: 'unit-find',
    path: '/units/find',
    component: () => import('@/views/units/UnitFind')
  }
]



// WEBPACK FOOTER //
// ./src/router/routeUnits.js